import React, { useEffect } from 'react';
import GeneralBuildingSearchBar from "../../../../shared/components/building_filters/GeneralBuildingSearchBar";
import RecentHistory from './RecentHistory';

import { withStyles, makeStyles } from '@material-ui/core/styles';

const searchBarBuildingStyles = makeStyles((theme) => ({
  appBar: {
	backgroundColor:'#F5F7FA !important',
	transform:'none !important',
	color:'#FFF !important',
	boxShadow:"none",
	padding: 'none !important',
	"& .MuiToolbar-gutters": {
	  paddingRight: "0px !important",
	  paddingLeft: "0px !important",
	},
	},
   
	grow: {
	  flexGrow: 1,
	},
	menuButton: {
	  marginRight: theme.spacing(2),
	},
	title: {
	  display: 'none',
	  [theme.breakpoints.up('sm')]: {
		display: 'block',
	  },
	},
	search: {
	  position: "relative",
	  borderRadius: theme.shape.borderRadius,
	  backgroundColor: " #FFF !important",
	  border:"2px solid #333",
	  marginRight: "0px !important",
	  marginLeft: "0px !important",
	  width: "100%",
	  [theme.breakpoints.up("sm")]: {
		marginLeft: 0, //theme.spacing(3),
		width: "100%",
		maxWidth: "none",
	  },
	  "& .c_search-result-container":{
		boxShadow:"none",
		top:"50px"
	  },
	  "& .c_input-tag": {
		background: "#A3ADC2",
		color: "#FFF",
		"& .mdi-icon": {
		  fill: "#FFF",
		},
	  },
	  "& .poly_map_launcher": {
		background: "#5C1F7A !important",
	  },
	  "&.MuiToolbar-gutters": {
		paddingRight: 0,
	  },
	  "& .mdi-icon": {
		fill: "#A3ADC2",
	  },
	  "& .c_search-nav": {
		color: "#A3ADC2",
		"& .c_nav-input.MuiInputBase-input":{
		  color: "#A3ADC2",
		
		},
	  
	  },

	},
	searchIcon: {
	  width: theme.spacing(7),
	  height: "100%",
	  position: "absolute",
	  pointerEvents: "none",
	  display: "flex",
	  alignItems: "center",
	  justifyContent: "center",
	},
	inputInput: {
	  padding: theme.spacing(1, 1, 1, 7) + " !important",
	  transition: theme.transitions.create("width"),
	  width: "100%",
	  [theme.breakpoints.up("md")]: {
		width: "80%",
	  },
	  color: "#222 !important",
	},

	inputRoot: {
	  color: 'inherit',
	  width: '100%',
	},

	sectionDesktop: {
	  display: 'none',
	  [theme.breakpoints.up('md')]: {
		display: 'flex',
	  },
	},
	sectionMobile: {
	  display: 'flex',
	  [theme.breakpoints.up('md')]: {
		display: 'none',
	  },
	},
	searchButton: {
	  color: "#FFF",
	  borderColor: "#FFF",
	  backgroundColor: "#5C1F7A",
	  margin: "0px 5px",
	  "&:hover": {
		borderColor: "#FFF", // A darker shade for the hover state
		backgroundColor: "#B070CC", // Slight background on hover
	  },
	  minWidth: 120,
	  height: 46,
	  marginLeft: -40,
	  boxShadow:
		"rgba(0, 0, 0, 0.1) 0px 0px 1px -3px, rgba(0, 0, 0, 0.1) 0px 1px 2px 0px, rgba(0, 0, 0, 0.1) 0px 1px 4px 0px",
	  "&.Mui-disabled": {
		boxShadow: "none",
		color: "#9600BF",
	  },
	},
  }));

export default function BuildingSearchSelector(props){
  const { updateBuildingReport } = props;
  
  return  (<div
		style={{
		  maxWidth: 900,
		  margin: "0 auto",
		 
		
		  width:"100%",
		  marginTop:280,
		}}
		
		>
		<h3
		style={{
		  fontWeight:800,
		  textAlign:"center",
		  textTransform:"uppercase"
		}}
		>Search for a Building to Generate a Report</h3>
		 <div
		style={{
		  maxWidth: 900,
		  
		  margin: "0 auto",
		  display: "flex",
		  gap: 0,
		  alignItems:"center"
		}}
	  >
	   
		<GeneralBuildingSearchBar
		  buildingFilter={
			'(ownership_type:"condo" OR ownership_type:"condo-retail" OR building_status:"sponsor" OR ownership_type:"coop" OR ownership_type:"rental")'
		  }
		  handleSearch={updateBuildingReport}
		  condoCoopOnly={true}
		  buildingAttributes={[]}
		  placeHolder={
			"Address or Building Name"
		  }
		  addBuilding={false}
		  buildingTab={null}
		  hideBoroHood={true}
		  hideAddIcon={true}
		  hideMapDraw={true}
		   searchBarStyles={searchBarBuildingStyles}
		   exitMessageData={{title:"Report Unavailable", message:"Building reports are currently available for condos and co-ops.  Click continue if you would like to learn more about this property on our public website."}}
		  className="internal-search"
		/>
	   
	  </div>
	  <hr/>
	  <RecentHistory {...props} handleSearch={updateBuildingReport} />
	</div>)
}
